export const GENERAL_ASSAY_PROVIDER_NAME = 'General';
